module.exports = __webpack_public_path__ + "static/img/sm_8.9ee23ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_8.png
// module id = CliU
// module chunks = 0